/**
 * ids.ts — ID-felter er STRING mot/fra backend
 *
 * Backend-kontrakt: tenant_id, user_id, file_id, role_id, permission_id,
 * forhandler_id, tuning_job_id og kjoretoy_id sendes og mottas som string.
 *
 * normalizeIds tåler at backend (fortsatt) svarer med number: alle verdier
 * under disse nøklene gjøres om til string, rekursivt. Brukes på JSON-responser
 * (safeFetch), JWT-payload og SSE-payloads, slik at resten av appen kan anta string.
 *
 * Funksjoner:
 * 1. normalizeIds — konverterer ID-felter (number → string) i vilkårlig JSON
 */

const ID_KEYS: ReadonlySet<string> = new Set([
  'tenant_id',
  'user_id',
  'file_id',
  'role_id',
  'permission_id',
  'forhandler_id',
  'tuning_job_id',
  'kjoretoy_id',
]);

/**
 * 1. normalizeIds — returnerer en kopi av `value` der alle ID-felter er string
 *
 * null/undefined og verdier som allerede er string beholdes uendret.
 */
export function normalizeIds<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeIds(item)) as unknown as T;
  }
  if (value !== null && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [key, v] of Object.entries(value as Record<string, unknown>)) {
      out[key] = ID_KEYS.has(key) && typeof v === 'number' ? String(v) : normalizeIds(v);
    }
    return out as T;
  }
  return value;
}
